import cx from "classnames";
import { Controller, useFormContext } from "react-hook-form";

import CodeEditor from "components/CodeEditor";
import { ErrorCircleColored } from "components/icons/generated";
import Box from "ds/components/Box";
import Callout from "ds/components/Callout";
import EmptyState from "ds/components/EmptyState";

import styles from "./styles.module.css";

type FormFileContentFieldProps = {
  name: string;
  className?: string;
  exceedsFileSize?: boolean;
};

const options = {
  quickSuggestions: false,
};

const FormFileContentField = ({ name, className, exceedsFileSize }: FormFileContentFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: "File content can't be empty" }}
      render={({ field, fieldState }) => (
        <Box direction="column" fullHeight>
          {fieldState.error?.message && (
            <Callout variant="danger">{fieldState.error?.message}</Callout>
          )}
          {exceedsFileSize ? (
            <EmptyState
              icon={ErrorCircleColored}
              title="File too large"
              caption="We can't display file preview. File is either larger than 0,5MB or in a wrong format."
            />
          ) : (
            <CodeEditor
              className={cx(styles.variablePreviewEditor, className)}
              body={field.value}
              onChange={field.onChange}
              language="json"
              options={options}
            />
          )}
        </Box>
      )}
    />
  );
};

export default FormFileContentField;
